import { ChangeDetectorRef, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { MRulesDataSource, MRulesGroup } from './data-source';

@Component({
  selector: 'm-rules',
  template: `
    <form nz-form>
      <m-rules-group class="m-rules" *ngFor="let group of mDataSource.groups" [group]="group">
        <ng-container *ngFor="let child of group.children; index as index">
          <div class="m-rules-child-container">
            <m-rules-item [item]="child" (delete)="onItemDelete(group, index)"></m-rules-item>
            <m-rules-link class="m-rules-link" *ngIf="index !== group.children.length - 1" [item]="child"></m-rules-link>
          </div>
        </ng-container>
        <m-rules-add *ngIf="group.creatable ? group.creatable(group) : true" (click)="addRule.emit(group)"></m-rules-add>
      </m-rules-group>
    </form>
  `,
  encapsulation: ViewEncapsulation.None,
  preserveWhitespaces: true,
  host: {
    class: 'm-rules'
  }
})
export class MRulesComponent {
  @Input() mDataSource = new MRulesDataSource({});
  @Output() readonly addRule = new EventEmitter<MRulesGroup>();

  constructor(private cdr: ChangeDetectorRef) {}

  render(): void {
    this.cdr.detectChanges();
  }

  onItemDelete(group: MRulesGroup, index: number): void {
    group.deleteItem(index);
  }
}
